<template>
  <div v-if="action">
    <component :is="type" :activity="activity"></component>

    <div class="text-muted">
      {{ formatDate(activity.created_at) }}
      by
      {{ activity.user ? activity.user.name : "BOLT SYSTEM" }}
    </div>
  </div>
</template>

<script type="text/babel">
import format from "../../../mixins/format";

import ContactCustomer from "./ActivityItem/ContactCustomer.vue";
import ContactUser from "./ActivityItem/ContactUser.vue";
import AppointmentCreated from "./ActivityItem/AppointmentCreated.vue";
import AppointmentRecurringCreated from "./ActivityItem/AppointmentRecurringCreated.vue";
import AppointmentCreatedToCustomer from "./ActivityItem/AppointmentCreatedToCustomer.vue";
import AppointmentCreatedToUser from "./ActivityItem/AppointmentCreatedToUser.vue";
import AppointmentCreatedToAssistant from "./ActivityItem/AppointmentCreatedToAssistant.vue";
import AppointmentUpdated from "./ActivityItem/AppointmentUpdated.vue";
import AppointmentUpdatedToCustomer from "./ActivityItem/AppointmentUpdatedToCustomer.vue";
import AppointmentUpdatedToUser from "./ActivityItem/AppointmentUpdatedToUser.vue";
import AppointmentUpdatedToAssistant from "./ActivityItem/AppointmentUpdatedToAssistant.vue";
import AppointmentDeleted from "./ActivityItem/AppointmentDeleted.vue";
import AppointmentDeletedToCustomer from "./ActivityItem/AppointmentDeletedToCustomer.vue";
import AppointmentDeletedToUser from "./ActivityItem/AppointmentDeletedToUser.vue";
import AppointmentDeletedToAssistant from "./ActivityItem/AppointmentDeletedToAssistant.vue";
import AppointmentNotificationEmailedToCustomer from "./ActivityItem/AppointmentNotificationEmailedCustomer.vue";
import AppointmentNotificationMessagedToCustomer from "./ActivityItem/AppointmentNotificationMessagedCustomer.vue";
import AppointmentTravelNotificationMessagedCustomer from "./ActivityItem/AppointmentTravelNotificationMessagedCustomer.vue";
import InvoiceCreated from "./ActivityItem/InvoiceCreated.vue";
import InvoiceUpdated from "./ActivityItem/InvoiceUpdated.vue";
import InvoiceEmailed from "./ActivityItem/InvoiceEmailed.vue";
import InvoiceSmsed from "./ActivityItem/InvoiceSmsed.vue";
import InvoiceRefunded from "./ActivityItem/InvoiceRefunded.vue";
import InvoiceQuoteAccepted from "./ActivityItem/InvoiceQuoteAccepted.vue";
import InvoicePaid from "./ActivityItem/InvoicePaid.vue";
import InvoiceUnpaid from "./ActivityItem/InvoiceUnpaid.vue";
import InvoiceDeleted from "./ActivityItem/InvoiceDeleted.vue";
import JobCreated from "./ActivityItem/JobCreated.vue";
import JobUpdated from "./ActivityItem/JobUpdated.vue";
import JobCompleted from "./ActivityItem/JobCompleted.vue";
import JobFollowUpAdded from "./ActivityItem/JobFollowUpAdded.vue";
import JobStatusChanged from "./ActivityItem/JobStatusChanged.vue";
import JobReferredByChanged from "./ActivityItem/JobReferredByChanged.vue";
import JobSetToUnreachable from "./ActivityItem/JobSetToUnreachable.vue";
import JobSetToReachable from "./ActivityItem/JobSetToReachable.vue";
import QuoteFollowUpMessagedCustomer from "./ActivityItem/QuoteFollowUpMessagedCustomer.vue";
import Note from "./ActivityItem/Note.vue";

export default {
  components: {
    ContactCustomer,
    ContactUser,
    AppointmentCreated,
    AppointmentRecurringCreated,
    AppointmentCreatedToCustomer,
    AppointmentCreatedToUser,
    AppointmentCreatedToAssistant,
    AppointmentUpdated,
    AppointmentUpdatedToCustomer,
    AppointmentUpdatedToUser,
    AppointmentUpdatedToAssistant,
    AppointmentDeleted,
    AppointmentDeletedToCustomer,
    AppointmentDeletedToUser,
    AppointmentDeletedToAssistant,
    AppointmentNotificationEmailedToCustomer,
    AppointmentNotificationMessagedToCustomer,
    AppointmentTravelNotificationMessagedCustomer,
    InvoiceCreated,
    InvoiceUpdated,
    InvoiceEmailed,
    InvoiceSmsed,
    InvoiceRefunded,
    InvoiceQuoteAccepted,
    InvoicePaid,
    InvoiceUnpaid,
    InvoiceDeleted,
    JobCreated,
    JobUpdated,
    JobCompleted,
    JobFollowUpAdded,
    JobStatusChanged,
    JobReferredByChanged,
    JobSetToUnreachable,
    JobSetToReachable,
    QuoteFollowUpMessagedCustomer,
    Note,
  },
  mixins: [format],

  props: ["activity"],

  data() {
    return {
      action: false,
      type: false,
    };
  },

  mounted() {
    if (this.activity.action) {
      this.action = this.activity.action;
    } else {
      this.action = "note";
    }

    switch (this.activity.action) {
      case "Ad hoc message/email sent to contact":
        this.type = "contact-customer";
        break;

      case "Ad hoc message/email sent to user":
        this.type = "contact-user";
        break;

      case "Appointment added":
        this.type = "appointment-created";
        break;

      case "Recurring appointment added":
        this.type = "appointment-recurring-created";
        break;

      case "Appointment creation messaged to customer":
        this.type = "appointment-created-to-customer";
        break;

      case "Appointment creation messaged to technician":
        this.type = "appointment-created-to-user";
        break;

      case "Appointment creation messaged to assistant":
        this.type = "appointment-created-to-assistant";
        break;

      case "Appointment updated":
        this.type = "appointment-updated";
        break;

      case "Appointment update messaged to customer":
        this.type = "appointment-updated-to-customer";
        break;

      case "Appointment update messaged to technician":
        this.type = "appointment-updated-to-user";
        break;

      case "Appointment update messaged to assistant":
        this.type = "appointment-updated-to-assistant";
        break;

      case "Appointment cancelled":
        this.type = "appointment-deleted";
        break;

      case "Appointment cancellation messaged to customer":
        this.type = "appointment-deleted-to-customer";
        break;

      case "Appointment cancellation messaged to technician":
        this.type = "appointment-deleted-to-user";
        break;

      case "Appointment cancellation messaged to assistant":
        this.type = "appointment-deleted-to-assistant";
        break;

      case "Appointment notification emailed to customer":
        this.type = "appointment-notification-emailed-customer";
        break;

      case "Appointment notification messaged to customer":
        this.type = "appointment-notification-messaged-customer";
        break;

      case "Appointment travel notification messaged to customer":
        this.type = "appointment-travel-notification-messaged-customer";
        break;

      case "Invoice created":
        this.type = "invoice-created";
        break;

      case "Invoice updated":
        this.type = "invoice-updated";
        break;

      case "Invoice paid":
        this.type = "invoice-paid";
        break;

      case "Invoice unpaid":
        this.type = "invoice-unpaid";
        break;

      case "Invoice emailed to customer":
        this.type = "invoice-emailed";
        break;

      case "Invoice SMSed to customer":
        this.type = "invoice-smsed";
        break;

      case "Invoice refunded":
        this.type = "invoice-refunded";
        break;

      case "Quote accepted":
        this.type = "invoice-quote-accepted";
        break;

      case "Invoice deleted":
        this.type = "invoice-deleted";
        break;

      case "Job created":
        this.type = "job-created";
        break;

      case "Job updated":
        this.type = "job-updated";
        break;

      case "Job completed as invoice has been paid":
        this.type = "job-completed";
        break;

      case "Job status manually changed":
        this.type = "job-status-changed";
        break;

      case "Job referred by manually changed":
        this.type = "job-referred-by-changed";
        break;

      case "Job follow-up added":
        this.type = "job-follow-up-added";
        break;

      case "Job set to Unreachable":
        this.type = "job-set-to-unreachable";
        break;

      case "Job set to Reachable":
        this.type = "job-set-to-reachable";
        break;

      case "Quote follow-up messaged to customer":
        this.type = "quote-follow-up-messaged-customer";
        break;

      default:
        this.type = "note";
    }
  },

  methods: {
    unpackJson(string, key) {
      if (string && string.length > 0) {
        const json = JSON.parse(string);
        return json[key] ? json[key] : "";
      }

      return "";
    },
  },
};
</script>
